export function parseJsonSilently(...args: Parameters<typeof JSON.parse>): any | null {
    try {
        return JSON.parse(...args);
    } catch (_) {
        return null;
    }
}
